'use strict';

const { getBossProjectileProfile } = require('./boss-projectiles');

const RAW_BOSS_ANIMALS = [
  ['rabbit', '兔子'], ['cat', '猫'], ['dog', '狗'], ['fox', '狐狸'], ['arctic-fox', '北极狐'],
  ['wolf', '狼'], ['brown-bear', '棕熊'], ['polar-bear', '北极熊'], ['panda', '熊猫'], ['red-panda', '小熊猫'],
  ['tiger', '老虎'], ['lion', '狮子'], ['leopard', '花豹'], ['cheetah', '猎豹'], ['lynx', '猞猁'],
  ['raccoon', '浣熊'], ['otter', '水獭'], ['beaver', '河狸'], ['hamster', '仓鼠'], ['guinea-pig', '豚鼠'],
  ['squirrel', '松鼠'], ['chinchilla', '龙猫'], ['hedgehog', '刺猬'], ['koala', '考拉'], ['kangaroo', '袋鼠'],
  ['wombat', '袋熊'], ['sloth', '树懒'], ['capybara', '水豚'], ['meerkat', '狐獴'], ['mole', '鼹鼠'],
  ['monkey', '猴子'], ['gorilla', '大猩猩'], ['orangutan', '红毛猩猩'], ['elephant', '大象'], ['giraffe', '长颈鹿'],
  ['zebra', '斑马'], ['rhino', '犀牛'], ['hippo', '河马'], ['horse', '马'], ['donkey', '驴'],
  ['cow', '奶牛'], ['goat', '山羊'], ['sheep', '绵羊'], ['pig', '小猪'], ['alpaca', '羊驼'],
  ['llama', '美洲驼'], ['deer', '梅花鹿'], ['moose', '驼鹿'], ['reindeer', '驯鹿'], ['camel', '骆驼'],
  ['yak', '牦牛'], ['buffalo', '水牛'], ['bison', '野牛'], ['antelope', '羚羊'], ['gazelle', '瞪羚'],
  ['seal', '海豹'], ['sea-lion', '海狮'], ['dolphin', '海豚'], ['whale', '鲸鱼'], ['orca', '虎鲸'],
  ['shark', '鲨鱼'], ['manta-ray', '蝠鲼'], ['octopus', '章鱼'], ['squid', '鱿鱼'], ['crab', '螃蟹'],
  ['lobster', '龙虾'], ['seahorse', '海马'], ['penguin', '企鹅'], ['owl', '猫头鹰'], ['eagle', '老鹰'],
  ['falcon', '猎鹰'], ['parrot', '鹦鹉'], ['flamingo', '火烈鸟'], ['peacock', '孔雀'], ['swan', '天鹅'],
  ['duck', '鸭子'], ['goose', '大鹅'], ['chicken', '小鸡'], ['turkey', '火鸡'], ['ostrich', '鸵鸟'],
  ['kiwi', '几维鸟'], ['crocodile', '鳄鱼'], ['turtle', '海龟'], ['chameleon', '变色龙'], ['gecko', '壁虎'],
  ['iguana', '鬣蜥'], ['snake', '小蛇'], ['frog', '青蛙'], ['axolotl', '六角恐龙'], ['butterfly', '蝴蝶'],
  ['bee', '蜜蜂'], ['ladybug', '瓢虫'], ['beetle', '甲虫'], ['dragonfly', '蜻蜓'], ['mantis', '螳螂'],
  ['snail', '蜗牛'], ['bat', '蝙蝠'], ['platypus', '鸭嘴兽'], ['skunk', '臭鼬']
];

const BOSS_ANIMALS = Object.freeze(RAW_BOSS_ANIMALS.map(([key, name], index) => Object.freeze({
  level: index + 1,
  key,
  name,
  filename: `${String(index + 1).padStart(2, '0')}-${key}.png`,
  projectileProfile: getBossProjectileProfile(index + 1)
})));

function getBossAnimal(level) {
  const safeLevel = Math.max(1, Math.min(BOSS_ANIMALS.length, Math.floor(Number(level) || 1)));
  return BOSS_ANIMALS[safeLevel - 1];
}

module.exports = { BOSS_ANIMALS, getBossAnimal };
